import React, { useState, useEffect, useRef } from "react";
import { get, post, put, destroy } from "../services/apiController";
import { TABLE_DEFAULT_LIMIT } from "../util/constant";
import {
  Table,
  Modal,
  Button,
  Form,
  FloatingLabel,
  Row,
  Col,
} from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { DeleteIcon, EditIcon } from "./icons";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import AlertIcon from "../../src/img.svg";
import PaginationInPage from "./Pagination";
import { GrDocumentExcel } from "react-icons/gr";

const Service = () => {
  const formFields = {
    name: "",
    branchId: "",
    monthly: "",
    quarterly: "",
    half_yearly: "",
    yearly: "",
  };
  const clickToDownload = useRef(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [serviceForm, setServiceForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [idToDeleted, setIdToDeleted] = useState("");
  const [deleteModel, setDeleteModel] = useState(false);
  const [serviceList, setServiceList] = useState([]);
  const [branchList, setBranchList] = useState([]);

  const handleShow = () => {
    setShowConfirmModel(true);
    setServiceForm(formFields);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    try {
      get("/services/?id=" + id).then((response) => {
        if (response.data.rows.length) {
          const data = response.data.rows[0];
          setServiceForm(data);
          setShowConfirmModel(true);
        } else {
          toast.error("No service found with this name");
        }
      });
    } catch (error) {
      toast.error(
        error?.response?.data?.data?.rows?.message || "Something went wrong"
      );
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setServiceForm({ ...serviceForm, [name]: value });
  };

  const handleRemove = (event, id) => {
    event.preventDefault();
    try {
      destroy("/services/" + id)
        .then((response) => {
          toast.success("Service Deleted successfully");
          setDeleteModel(false);
          getServices();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.data?.message || err.message);
        });
    } catch (err) {
      toast.error(err?.message || "Something went wrong", { autoClose: 3000 });
    }
  };

  const handleConfirmDeleteModal = (e, id) => {
    e.preventDefault();
    setDeleteModel(true);
    setIdToDeleted(id);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if ("id" in serviceForm) {
      try {
        put(serviceForm, "/services/" + serviceForm.id)
          .then((response) => {
            toast.success("Service updated successfully");
            setShowConfirmModel(false);
            getServices();
          })
          .catch((err) => {
            toast.error(
              err?.response?.data?.data?.message || err?.response?.data?.message
            );
          });
      } catch (err) {
        toast.error(err.message, { autoClose: 3000 });
      }
    } else {
      try {
        post(serviceForm, "/services")
          .then((response) => {
            toast.success("Service added successfully");
            setShowConfirmModel(false);
            getServices();
          })
          .catch((err) => {
            toast.error(
              err?.response?.data?.data?.message || err?.response?.data?.message
            );
          });
      } catch (err) {
        toast.error(err.message, { autoClose: 2000 });
      }
    }
  };

  const getServices = (conditions) => {
    try {
      let url = "";
      if (conditions === "excel") {
        url = `/services/?conditionType=download`;
      } else {
        url = `/services/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`;
      }
      get(url).then((response) => {
        if (conditions === "excel") {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setServiceList(response?.data?.rows);
          setTotalRecords(response.data.count);
        }
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || "Something went wrong");
    }
  };

  function getBranchDropdown() {
    get("/branches").then((response) => {
      setBranchList(response.data.rows);
    });
  }

  useEffect(() => {
    getBranchDropdown();
  }, []);

  useEffect(() => {
    getServices();
  }, [currentPage]);

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="card">
        <div
          className="card-header white-color"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem 1.7rem",
          }}
        >
          <h4 className="card-title mb-0" style={{ fontSize: "16px" }}>
            Services | {totalRecords ?? 0}
          </h4>
          <button
            type="button"
            className="btn app-btn-default dark-color "
            onClick={handleShow}
          >
            Add New Service
          </button>
          <a
            ref={clickToDownload}
            href="/"
            target="_blank"
            className="hiddenItem"
          >
            HiddenClick
          </a>
          <GrDocumentExcel
            onClick={() => getServices("excel")}
            style={{ width: "70px", height: "30px", cursor: "pointer" }}
            title="Download Excel report"
            className="react-icons green"
          />
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Service Name</th>
                    <th>Branch</th>
                    <th>1 Month</th>
                    <th>3 Months</th>
                    <th>6 Months</th>
                    <th>12 Months</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {serviceList.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>
                          {(currentPage - 1) * TABLE_DEFAULT_LIMIT +
                            (index + 1)}
                        </td>
                        <td>{item?.name}</td>
                        <td>{item?.Branch?.name}</td>
                        <td>{item?.monthly}</td>
                        <td>{item?.quarterly}</td>
                        <td>{item?.half_yearly}</td>
                        <td>{item?.yearly}</td>
                        <td className="actions">
                          <span
                            onClick={(e) => handleEdit(e, item?.id)}
                            className="edit-icon"
                          >
                            <EditIcon />
                          </span>
                          <Link
                            onClick={(e) =>
                              handleConfirmDeleteModal(e, item?.id)
                            }
                            className="delete"
                            to="/"
                          >
                            <DeleteIcon />
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={showConfirmModel}
        backdrop="static"
        keyboard={false}
        className="request-modal"
      >
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title>
            {"id" in serviceForm ? "Edit Service" : "Add Service"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off">
            <Row>
              <Col xs={6}>
                <FloatingLabel
                  controlId="floatingInput"
                  label="Service Name"
                  className="mb-3"
                >
                  <Form.Control
                    className="input"
                    value={serviceForm.name}
                    name="name"
                    onChange={handleChange}
                    type="text"
                    placeholder="Service Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel
                  controlId="floatingInput"
                  label="Branch's Name"
                  className="mb-3"
                >
                  <select
                    name="branchId"
                    value={serviceForm.branchId}
                    onChange={handleChange}
                    aria-label="Floating label select example"
                    className="form-select"
                    required
                  >
                    <option value="">Select Branch</option>
                    {branchList.map((item) => {
                      return (
                        <option key={item?.id} value={item.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </select>
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <FloatingLabel
                  controlId="floatingInput"
                  label="1 Month Amount"
                  className="mb-3"
                >
                  <Form.Control
                    className="input"
                    value={serviceForm.monthly}
                    name="monthly"
                    onChange={handleChange}
                    type="number"
                    placeholder="Monthly Amount"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={3}>
                <FloatingLabel
                  controlId="floatingInput"
                  label="3 Months Amount"
                  className="mb-3"
                >
                  <Form.Control
                    className="input"
                    value={serviceForm.quarterly}
                    name="quarterly"
                    onChange={handleChange}
                    type="number"
                    placeholder="Quarterly Amount"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={3}>
                <FloatingLabel
                  controlId="floatingInput"
                  label="6 Months Amount"
                  className="mb-3"
                >
                  <Form.Control
                    className="input"
                    value={serviceForm.half_yearly}
                    name="half_yearly"
                    onChange={handleChange}
                    type="number"
                    placeholder="Half Yearly Amount"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={3}>
                <FloatingLabel
                  controlId="floatingInput"
                  label="12 Months Amount"
                  className="mb-3"
                >
                  <Form.Control
                    className="input"
                    value={serviceForm.yearly}
                    name="yearly"
                    onChange={handleChange}
                    type="number"
                    placeholder="Yearly Amount"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <div className="container text-center">
              <Button
                type="submit"
                onClick={handleSubmit}
                className="add-request-btn mt-4 mb-3"
              >
                {"id" in serviceForm ? "Update" : "Add"}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal
        size="sm"
        show={deleteModel}
        backdrop="static"
        keyboard={false}
        className="request-modal"
      >
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Service Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="alert icon" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button
              onClick={() => setDeleteModel(false)}
              className="btn app-btn-default btn-sm"
            >
              Cancel
            </button>
            <button
              onClick={(event) => handleRemove(event, idToDeleted)}
              className="btn app-btn-danger btn-sm"
            >
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Service;
